(() => {
  'use strict';
  const ownedDialogs = () => [...document.querySelectorAll('dialog.gcp-exp')];
  const syncScrollLock = () => document.documentElement.classList.toggle('gcp-exp-dialog-open', ownedDialogs().some(dialog => dialog.open));
  const initializeDialog = dialog => {
    if (dialog.dataset.gcpDialogReady === 'true') return;
    dialog.dataset.gcpDialogReady = 'true';
    dialog.addEventListener('close', () => {
      syncScrollLock();
      const opener = dialog.gcpReturnFocus;
      if (opener?.isConnected && opener.getClientRects().length) opener.focus({preventScroll:true});
    });
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-gcp-dialog-close]')) dialog.close();
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
  };
  const helpers = {initializeDialog, syncScrollLock};
  const imports = new Map();
  const loadStyle = href => {
    if (!href) return Promise.resolve();
    const key = 'css:' + href;
    if (!imports.has(key)) imports.set(key, new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet'; link.href = href;
      link.addEventListener('load', resolve, {once:true});
      link.addEventListener('error', () => { imports.delete(key); link.remove(); reject(new Error()); }, {once:true});
      document.head.append(link);
    }));
    return imports.get(key);
  };
  const loadModule = (script, css) => Promise.all([import(new URL(script,document.baseURI).href), loadStyle(css)]).then(([module]) => module);
  const closeMenu = trigger => {
    let returnFocus = trigger;
    const menu = trigger.closest('main-menu');
    const disclosure = menu?.querySelector('.main-nav__item--dropdown.is-open');
    if (disclosure && typeof menu.close === 'function') { menu.close(disclosure, false); menu.toggleOverlay?.(false); menu.childNavOpen = false; }
    if (menu?.querySelector('.main-menu__content.is-open') && typeof menu.closeMainMenu === 'function') { returnFocus = menu.querySelector('.main-menu__toggle'); menu.closeMainMenu(false); }
    return returnFocus;
  };
  const boot = () => {
    const main = document.querySelector('main#main-content');
    if (main && !main.hasAttribute('tabindex')) main.tabIndex = -1;
    if (document.querySelector('[data-gcp-guide-template]')) document.querySelectorAll('[data-gcp-guide-open]').forEach(trigger => trigger.setAttribute('aria-haspopup','dialog'));
    document.querySelectorAll('[data-gcp-style-library]').forEach(library => {
      if (library.dataset.libraryScript) import(new URL(library.dataset.libraryScript,document.baseURI).href).then(module => module.initializeLibrary(library, helpers)).catch(() => {});
    });
  };
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-gcp-guide-open]');
    if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || trigger.hasAttribute('aria-busy')) return;
    const isGuide = trigger.hasAttribute('data-gcp-guide-open');
    const template = document.querySelector('[data-gcp-guide-template]');
    if (isGuide && (!template || typeof HTMLDialogElement === 'undefined')) return;
    event.preventDefault(); trigger.setAttribute('aria-busy','true');
    try {
      const module = await loadModule(template.dataset.script, template.dataset.css);
      if (!module || !trigger.isConnected) return;
      let returnFocus = closeMenu(trigger);
      module.openGuide(trigger, returnFocus, helpers);
    } catch (error) {
      console.warn('Packaging helper could not open.', error);
      if (trigger instanceof HTMLAnchorElement && trigger.href && !trigger.getAttribute('href').startsWith('#')) window.location.assign(trigger.href);
    } finally { trigger.removeAttribute('aria-busy'); }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || ownedDialogs().some(dialog => dialog.open)) return;
    const menu = document.querySelector('store-header[data-gcp-experience-navigation] main-menu:has(.main-menu__content.is-open)');
    if (!menu || typeof menu.closeMainMenu !== 'function') return;
    menu.closeMainMenu(false); menu.toggleOverlay?.(false); menu.querySelector('.main-menu__toggle')?.focus();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
